import React, { useEffect, useState } from 'react';
import { masterService } from "services";

const useCountries = () => {
    const [countries, setCountries] = useState({});

    const handleApi = async () => {
        try {
            const response = await masterService.getCountries();
            setCountries(response.data.data)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        handleApi();
    }, []);

    return { countries };
}

export default useCountries